import { App, type URLOpenListenerEvent } from '@capacitor/app'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

/**
 * Listens for deep link / app URL open events from Capacitor.
 * Extracts the path from the URL and navigates via react-router.
 *
 * Must be rendered inside `<IonReactRouter>`.
 */
export const AppUrlListener = () => {
  const history = useHistory()

  useEffect(() => {
    const handler = App.addListener(
      'appUrlOpen',
      (event: URLOpenListenerEvent) => {
        try {
          const url = new URL(event.url)
          const path = url.pathname + url.search
          if (path) {
            history.push(path)
          }
        } catch {
          // Invalid URL — ignore
        }
      },
    )

    return () => {
      handler.then((h) => h.remove())
    }
  }, [history])

  return null
}
